import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../img/logo.png";
import metaimg from "../img/metaimg.png";
import PropagateLoader from "react-spinners/HashLoader";
import { EthereumAuthProvider, SelfID } from "@self.id/web";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth } from "../firebase";
import uuid from "react-uuid";
const Login = () => {
  const [err, setErr] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 2500);
  }, []);
  const override = `
  display: block;
  margin: 0 auto;
  border-color: red;
  `;
  const style = {
    position: "fixed",
  };
  const checkCeramic = async (accounts) => {
    const authProvider = new EthereumAuthProvider(window.ethereum, accounts[0]);
    const selfid = await SelfID.authenticate({
      authProvider: authProvider,
      ceramic: "https://ceramic.metagame.wtf/",
      connectNetwork: "mainnet",
      threeidConnect: true,
    });
    const ret = await selfid.get("basicProfile");
    const email = `${accounts[0]}@doxdom.com`;
    const password = "omrssb494334";
    const res = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(res.user, {
      displayName: accounts[0],
    });
    navigate("/user");
  };
  const handleConnect = async () => {
    if (typeof window.ethereum !== "undefined") {
      const { ethereum } = window;
      const currChainId = await ethereum.request({ method: "net_version" });
      if (currChainId != 1) {
        try {
          await ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: `0x1` }],
          });
        } catch (switchError) {
          console.log("error");
          if (switchError.code === 4902) {
            alert("Add the etherum chain");
          }
        }
      }
      try {
        await ethereum.request({ method: "eth_requestAccounts" });
      } catch (error) {
        console.log(error);
      }
      const accounts = await ethereum.request({ method: "eth_accounts" });
      const change = document.getElementById("change");
      change.innerHTML = "Connected";
      setIsLoading(true);
      await checkCeramic(accounts);
    } else {
      setErr(true);
    }
  };
  return (
    <div className="loginForm">
      {isLoading && (
        <PropagateLoader
          color={"#4d00ac"}
          isLoading={isLoading}
          css={override}
          size={60}
          style={style}
        />
      )}
      {!isLoading && (
        <div className="container">
          <div className="name">
            <img src={logo} alt=""></img>
          </div>
          <div className="steps">
            <div className="stepf">Step 1</div>
            <hr></hr>
            <div className="step">Step 2</div>
            <hr></hr>
            <div className="step">Step 3</div>
          </div>
          <div className="metamask">
            <span className="hey">Hey! Welcome to Doxdom</span>
            <span className="connect">
              Connect your Metamask wallet to continue.
            </span>
            <button className="metaDiv" onClick={handleConnect}>
              <img src={metaimg} alt=""></img>
              <span id="change">Connect Metamask</span>
            </button>
            {err && <span>Please install Metamask</span>}
          </div>
        </div>
      )}
    </div>
  );
};

export default Login;
